import { FRIENDLY_CONTENT_TYPES } from 'constants-content';

import { contentNotificationCollectables } from './contentNotification.collectable';
import type { DraftContentType } from '../../../types/content/DraftContent';
import { contentFeatureCollectables } from './contentFeature.collectable';
import { contentDataFieldCollectables } from './contentDataField.collectable';

export const draftContentCollectables = (
  draftContent?: Partial<DraftContentType>
) => {
  if (!draftContent) return;

  return {
    contentId: draftContent._id,
    contentType: FRIENDLY_CONTENT_TYPES[draftContent?.type!],
    contentName: draftContent.name,
    contentCategory: draftContent.category,
    contentName_l10n: draftContent.name_l10n,
    contentDescription: draftContent.description,
    contentDescription_l10n: draftContent.description_l10n,
    contentIsEvent: draftContent.isEvent,
    publishDate: draftContent.liveDate,
    unpublishDate: draftContent.unpublishDate,
    eventLiveDate: draftContent.startDate,
    eventEndDate: draftContent.endDate,
    channelId: draftContent.channel?._id,
    channelName: draftContent.channel?.name,
    // FIX ME: flatten notifications data
    notifications: draftContent.notifications?.map(
      contentNotificationCollectables
    ),
    templateName: draftContent.templateName,
    isInteractive: draftContent.isInteractive,
    // FIX ME: flatten features data
    enabledFeatures: contentFeatureCollectables(draftContent.features || []),
    // FIX ME: flatten data fields data
    dataFields: contentDataFieldCollectables(draftContent.data),
  };
};
